<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'SETTINGS' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm" routerLink="/integration">
                        <i class="bi bi-backspace"></i> {{ 'BACK_TO_LIST' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="onSave()" [disabled]="form.invalid || loading">
                        <i class="bi bi-save"></i> {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <div class="card-body-title">{{ 'INTEGRATION.CONECTION_OPTIONS_TO' | translate }} Ozon</div>

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                    <div class="row">

                        <div class="col-6 form-group">
                            <label for="client_id" class="label"><span class="star">*</span> ID {{ 'INTEGRATION.BUYER' | translate }} </label>
                            <input type="text" class="form-control" id="client_id" formControlName="client_id">
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.clinet_id">
                                    <div class="text-error" *ngIf="validation('client_id', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-6 form-group">
                            <label for="apikey" class="label"><span class="star">*</span> API {{ 'INTEGRATION.KEY' | translate }}</label>
                            <input type="text" class="form-control" id="apikey" formControlName="apikey">
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.apikey">
                                    <div class="text-error" *ngIf="validation('apikey', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </form>

            </div>

        </div>

    </div>
</div>